export default __webpack_public_path__ + "static/media/app-active.deb0591a.svg";